import { notify, Page } from "@general-backoffice/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { forgotPassword } from "../../../api";
import getErrorMessage from "../../../utils/getErrorMessage";

const ForgottenPassword: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("auth", { keyPrefix: "forgottenPassword" });

  const onSubmit = async (email: string) =>
    forgotPassword(email)
      .then(() => {
        notify.success(t("successMessage"));
        navigate("/auth/login");
      })
      .catch((err: unknown) => {
        notify.error(getErrorMessage(err, "Error"));
      });

  return (
    <Page.ForgottenPassword
      title={t("title")}
      lead={t("lead")}
      emailPlaceholder={t("emailPlaceholder")}
      loginText={t("loginText")}
      invalidEmailFeedbackText={t("invalidEmailFeedbackText")}
      submitText={t("submitText")}
      onSubmit={onSubmit}
      onClickLogin={() => navigate("/auth/login")}
    />
  );
};

export default ForgottenPassword;
